import { jsx as e } from "react/jsx-runtime";
const a = ({ rotation: t, begin: r }) => /* @__PURE__ */ e("g", { transform: `rotate(${t} 10 10)`, children: /* @__PURE__ */ e("rect", { x: "9", y: "3", rx: "1", ry: "1.232", width: "2", height: "4.4", children: /* @__PURE__ */ e(
  "animate",
  {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: `${r}s`,
    repeatCount: "indefinite"
  }
) }) });
export {
  a as Rectangle
};
//# sourceMappingURL=Rectangle.js.map
